import { constants } from "@common/_constants";
import { AppInsights } from "applicationinsights-js";

let isApplicationInsightsInitialized = false;

export const TelemetryService = {
    init,
    trackRoute,
    trackDependency,
    trackException,
    trackEvent,
    setAuthenticatedUserContext,
    userLogin,
    userLogout,
};

function init() {
    if (
        !isApplicationInsightsInitialized &&
        constants.GlobalConfig.applicationInsightsKey
    ) {
        try {
            AppInsights.downloadAndSetup({
                instrumentationKey:
                    constants.GlobalConfig.applicationInsightsKey,

                // we explicitly log in our error boundary
                disableExceptionTracking: true,

                disableAjaxTracking: true,
                disableFetchTracking: true,
            });
            isApplicationInsightsInitialized = true;
        } catch (Err) {
            isApplicationInsightsInitialized = false;
        }
    }
    return isApplicationInsightsInitialized;
}

function trackRoute(name, url, properties) {
    return (
        TelemetryService.init() &&
        AppInsights.trackPageView(name, url, properties)
    );
}

function trackEvent(name, properties) {
    return TelemetryService.init() && AppInsights.trackEvent(name, properties);
}

function trackException(exception, handledAt, properties) {
    return (
        TelemetryService.init() &&
        AppInsights.trackException(exception, handledAt, properties)
    );
}

function trackDependency(
    id,
    method,
    absoluteUrl,
    pathName,
    success,
    resultCode
) {
    return (
        TelemetryService.init() &&
        AppInsights.trackDependency(
            id,
            method,
            absoluteUrl,
            pathName,
            null,
            success,
            resultCode
        )
    );
}

interface UserLoginInfo {
    email: string;
    applicationName?: string;
    fullName?: string;
    roleId?: number;
}

function userLogin(user: UserLoginInfo) {
    setAuthenticatedUserContext(user.email);

    //Help Scout User Identify and Form Prefill
    if (!!window.Beacon) {
        window.Beacon("identify", {
            name: user.fullName,
            email: user.email,
        });
        window.Beacon("prefill", {
            name: user.fullName,
            email: user.email,
        });
    }

    //PostHog User Identify and Set
    if (!!window.posthog) {
        window.posthog.identify(user.email);

        window.posthog.people.set({
            email: user.email,
            fullName: user.fullName,
            roleId: user.roleId,
        });
    }
}

function userLogout() {
    if (!!window.Beacon) {
        window.Beacon("destroy");
    }

    if (!!window.posthog) {
        window.posthog.reset();
    }
}

function setAuthenticatedUserContext(authenticatedUserId) {
    return (
        TelemetryService.init() &&
        AppInsights.setAuthenticatedUserContext(authenticatedUserId)
    );
}
